// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../lib/api";
// import profileimage from "../assets/profileimage.png";
// import Icons from "../components/icons";
// import "./styles/SetUpProfile.css";

// const SetUpProfile = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     name: "",
//     dateOfBirth: "",
//     bloodGroup: "",
//     personalEmail: "",
//     phone: "",
//     alternatePhone: "",
//     address: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   // Get token from invite link
//   const inviteToken = new URLSearchParams(window.location.search).get("token");

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     if (error) setError("");
//   };

//   const validateForm = () => {
//     if (!formData.name.trim()) {
//       return "Name is required";
//     }

//     if (!formData.dateOfBirth) {
//       return "Date of Birth is required";
//     }

//     if (!formData.bloodGroup.trim()) {
//       return "Blood Group is required";
//     }

//     if (!formData.personalEmail.trim()) {
//       return "Email is required";
//     }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//     if (!emailRegex.test(formData.personalEmail)) {
//       return "Invalid email format";
//     }

//     if (!formData.phone.trim()) {
//       return "Phone number is required";
//     }

//     if (!formData.address.trim()) {
//       return "Address is required";
//     }

//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const validationError = validateForm();

//     if (validationError) {
//       setError(validationError);
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");

//       const payload = {
//         token: inviteToken,
//         ...formData,
//       };

//       const response = await api.post("/onboarding/profile", payload);

//       if (response.data.success) {
//         // Check role — viewer skips documents, goes straight to password
//         const infoRes = await api.get(
//           `/auth/onboarding/info?token=${inviteToken}`,
//         );
//         const { requiresDocuments } = infoRes.data.data;

//         if (requiresDocuments) {
//           navigate(
//             `/upload-documents?token=${encodeURIComponent(inviteToken)}`,
//           );
//         } else {
//           navigate(`/set-password?token=${encodeURIComponent(inviteToken)}`);
//         }
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || "Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="setup-profile">
//       {/* LEFT SIDE */}
//       <div className="left-panel">
//         <img src={profileimage} alt="Setup Profile" className="profile-image" />
//       </div>

//       {/* RIGHT SIDE */}
//       <div className="right-panel">
//         {/* LOGO */}
//         <div className="setup-brand-logo">
//           <Icons.Logo />
//           <span>QwickHub</span>
//         </div>

//         {/* CARD */}
//         <div className="profile-card">
//           <h1 className="profile-title">Set Up Your Profile</h1>

//           <form onSubmit={handleSubmit} noValidate>
//             {error && (
//               <div className="error-box">
//                 <p>{error}</p>
//               </div>
//             )}

//             {/* Name */}
//             <div className="form-group">
//               <label>Name</label>
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Enter Your Name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 disabled={loading}
//               />
//             </div>

//             {/* DOB */}
//             <div className="form-group">
//               <label>Date Of Birth</label>
//               <input
//                 type="date"
//                 name="dateOfBirth"
//                 value={formData.dateOfBirth}
//                 onChange={handleChange}
//                 disabled={loading}
//               />
//             </div>

//             {/* Blood Group */}
//             <div className="form-group">
//               <label>Blood Group</label>
//               <input
//                 type="text"
//                 name="bloodGroup"
//                 placeholder="Enter your blood group"
//                 value={formData.bloodGroup}
//                 onChange={handleChange}
//                 disabled={loading}
//               />
//             </div>

//             {/* Email */}
//             <div className="form-group">
//               <label>Email ID</label>
//               <input
//                 type="email"
//                 name="personalEmail"
//                 placeholder="Enter your personal email address"
//                 value={formData.personalEmail}
//                 onChange={handleChange}
//                 disabled={loading}
//               />
//             </div>

//             {/* Phone */}
//             <div className="form-group">
//               <label>Phone No</label>
//               <input
//                 type="text"
//                 name="phone"
//                 placeholder="Enter your phone number"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 disabled={loading}
//               />
//             </div>

//             {/* Alternate Phone */}
//             <div className="form-group">
//               <label>Alternative Phone No</label>
//               <input
//                 type="text"
//                 name="alternatePhone"
//                 placeholder="Enter your alternative phone number"
//                 value={formData.alternatePhone}
//                 onChange={handleChange}
//                 disabled={loading}
//               />
//             </div>

//             {/* Address */}
//             <div className="form-group">
//               <label>Address</label>
//               <textarea
//                 name="address"
//                 placeholder="Enter your address"
//                 value={formData.address}
//                 onChange={handleChange}
//                 disabled={loading}
//               />
//             </div>

//             <button type="submit" className="next-button" disabled={loading}>
//               {loading ? "Saving..." : "Next →"}
//             </button>
//           </form>

//           <p className="setup-footer">© QwickBit Technologies Pvt Ltd, 2026</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SetUpProfile;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useOnboarding from "../hooks/useOnboarding";
import profileimage from "../assets/profileimage.png";
import Icons from "../components/icons";
import "./styles/SetUpProfile.css";


const SetUpProfile = () => {
  const navigate = useNavigate();

  // ── Redux ─────────────────────────────────────────────────────────
  const {
    isSubmittingProfile,
    profileError,
    profileSuccess,
    requiresDocuments,
    role,
    email,
    submitProfile,
    loadInfo,
  } = useOnboarding();

  // An invited admin only fills in personal information — document
  // verification does not apply to them, so this page is their last form step
  // and its button reads "Submit" rather than "Next →".
  const isAdmin = String(role || "").toLowerCase() === "admin";
  // Clients get a reduced form: name + phone only.
  const isViewer = String(role || "").toLowerCase() === "viewer";

  const [formData, setFormData] = useState({
    name: "",
    dateOfBirth: "",
    bloodGroup: "",
    personalEmail: "",
    phone: "",
    alternatePhone: "",
    address: "",
  });
  

  const [localError, setLocalError] = useState("");

  // Get token from URL
  const inviteToken = new URLSearchParams(window.location.search).get("token");

  // Load onboarding info on mount to get role/requiresDocuments
  useEffect(() => {
    if (inviteToken) {
      loadInfo(inviteToken);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // A client invited from a project carries that project's id in the link;
  // remember it so their first sign-in opens the project (see Login.js).
  useEffect(() => {
    const projectId = new URLSearchParams(window.location.search).get("project");
    if (projectId && /^[a-f0-9]{24}$/i.test(projectId)) {
      try {
        localStorage.setItem("qh_join_project", projectId);
      } catch {}
    }
  }, []);

  // Navigate after success
  useEffect(() => {
    if (profileSuccess) {
      // Admins skip document verification (the backend still reports
      // requiresDocuments: true for every non-viewer role, so the role check
      // has to happen here) and go straight to setting their password, which
      // then lands on the congrats page.
      if (requiresDocuments && !isAdmin) {
        navigate(`/upload-documents?token=${encodeURIComponent(inviteToken)}`);
      } else {
        navigate(`/set-password?token=${encodeURIComponent(inviteToken)}`);
      }
    }
  }, [profileSuccess]); // eslint-disable-line react-hooks/exhaustive-deps

const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" || name === "alternatePhone") {
      const digitsOnly = value.replace(/\D/g, "");
      setFormData((prev) => ({ ...prev, [name]: digitsOnly }));
    } else if (name === "name") {
      const lettersOnly = value.replace(/[^a-zA-Z\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: lettersOnly }));
} else if (name === "address") {
      const limited = value.slice(0, 100);
      setFormData((prev) => ({ ...prev, [name]: limited }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    if (localError) setLocalError("");
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "Enter your DOB";
    const date = new Date(dateString + "T00:00:00");
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  // Date bounds for DOB picker: must be at least 18 years old
const getDateBounds = () => {
  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  const minDate = new Date(today.getFullYear() - 100, today.getMonth(), today.getDate());
  const toISO = (d) => d.toISOString().split("T")[0];
  return { min: toISO(minDate), max: toISO(maxDate) };
};

const { min: minDOB, max: maxDOB } = getDateBounds();

const isAtLeast18 = (dateString) => {
  if (!dateString) return false;
  const dob = new Date(dateString + "T00:00:00");
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
  return age >= 18;
};
const validateForm = () => {
  if (!formData.name.trim()) return "Name is required";
  if (!/^[a-zA-Z\s]+$/.test(formData.name.trim())) return "Name must contain only alphabets";

  // Clients (viewers) supply only their name and phone — the employment
  // fields below do not apply to them, and their email is already known.
  if (isViewer) {
    if (!formData.phone.trim()) return "Phone number is required";
    if (!/^\d{10}$/.test(formData.phone)) return "Phone number must be exactly 10 digits";
    return null;
  }

  if (!formData.dateOfBirth) return "Date of Birth is required";
  if (!isAtLeast18(formData.dateOfBirth)) return "You must be at least 18 years old";
  if (!formData.bloodGroup.trim()) return "Blood Group is required";
  if (!formData.personalEmail.trim()) return "Email is required";
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(formData.personalEmail)) return "Invalid email format";
  if (!formData.phone.trim()) return "Phone number is required";
  if (!/^\d{10}$/.test(formData.phone)) return "Phone number must be exactly 10 digits";
  if (!formData.alternatePhone.trim()) return "Alternate phone number is required";
  if (!/^\d{10}$/.test(formData.alternatePhone)) return "Alternate phone number must be exactly 10 digits";
  if (!formData.address.trim()) return "Address is required";
if (formData.address.trim().length < 15) return "Address must be at least 15 characters";
  if (formData.address.trim().length > 100) return "Address must not exceed 100 characters";
  return null;
};
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      setLocalError(validationError);
      return;
    }
    // Dispatch Redux thunk
    await submitProfile({ token: inviteToken, ...formData });
  };

  // Use Redux error OR local validation error
  const displayError = localError || profileError;

  return (
    <div className="setup-profile">
      {/* LEFT SIDE */}
      <div className="left-panel">
        <img src={profileimage} alt="Setup Profile" className="profile-image" />
      </div>

      {/* RIGHT SIDE */}
      <div className="right-panel">
        {/* LOGO */}
        <div className="setup-brand-logo">
          <Icons.Logo />
          <span>QwickHub</span>
        </div>

        {/* CARD */}
        <div className="profile-card">
          <h1 className="profile-title">Set Up Your Profile</h1>

         <form onSubmit={handleSubmit} noValidate>
            {/* Name */}
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                name="name"
                placeholder="Enter Your Name"
                value={formData.name}
                onChange={handleChange}
                disabled={isSubmittingProfile}
              />
            </div>

            {/* Clients (viewers) only provide name + phone, so the
                employment fields below are skipped for them. */}
            {!isViewer && (
              <>
            {/* DOB */}
<div className="form-group">
  <label>Date Of Birth</label>
  <div
    className={`date-input-wrapper ${formData.dateOfBirth ? "has-value" : ""}`}
    onClick={() => document.getElementById("dateOfBirth").showPicker()}
  >
    <Icons.Date />
  {formData.dateOfBirth ? (
  <span className="date-display">
    {formatDateForDisplay(formData.dateOfBirth)}
  </span>
) : (
  <span className="date-placeholder">Enter your DOB</span>
)}
<input
  id="dateOfBirth"
  type="date"
  name="dateOfBirth"
  value={formData.dateOfBirth}
  onChange={handleChange}
  disabled={isSubmittingProfile}
  min={minDOB}
  max={maxDOB}
/>
  </div>
</div>

            {/* Blood Group */}
            <div className="form-group">
              <label>Blood Group</label>
              <input
                type="text"
                name="bloodGroup"
                placeholder="Enter your blood group"
                value={formData.bloodGroup}
                onChange={handleChange}
                disabled={isSubmittingProfile}
              />
            </div>

            {/* Email */}
            <div className="form-group">
              <label> Personal Email ID</label>
              <input
                type="email"
                name="personalEmail"
                placeholder="Enter your personal email address"
                value={formData.personalEmail}
                onChange={handleChange}
                disabled={isSubmittingProfile}
              />
            </div>
              </>
            )}

            {/* Clients see the address their invite was sent to, read-only —
                it is already their account email, so re-typing it would only
                risk a mismatch. */}
            {isViewer && (
              <div className="form-group">
                <label>Email ID</label>
                <input
                  type="email"
                  value={email || ""}
                  readOnly
                  disabled
                />
              </div>
            )}

            {/* Phone */}
            <div className="form-group">
              <label>Phone No</label>
          <input
  type="text"
  name="phone"
  placeholder="Enter your 10-digit phone number"
  maxLength={10}
                value={formData.phone}
                onChange={handleChange}
                disabled={isSubmittingProfile}
              />
            </div>

            {!isViewer && (
              <>
            {/* Alternate Phone */}
            <div className="form-group">
              <label>Alternative Phone No</label>
              <input
  type="text"
  name="alternatePhone"
  placeholder="Enter your 10-digit alternative number"
  maxLength={10}
                value={formData.alternatePhone}
                onChange={handleChange}
                disabled={isSubmittingProfile}
              />
            </div>

     {/* Address */}
            <div className="form-group">
              <label>Address</label>
              <textarea
                name="address"
                placeholder="Enter your address "
                value={formData.address}
                onChange={handleChange}
                disabled={isSubmittingProfile}
                maxLength={100}
              />
           <span
                className="char-count"
                style={{
                  fontSize: "12px",
                  color: "#888",
                  display: "block",
                  textAlign: "right",
                }}
              >
                {formData.address.length}/100
              </span>
            </div>
              </>
            )}

            {displayError && (
              <div className="error-box">
                <p>{displayError}</p>
              </div>
            )}

            <button
              type="submit"
              className="next-button"
              disabled={isSubmittingProfile}
            >
              {isSubmittingProfile
                ? "Saving..."
                : isAdmin
                  ? "Submit"
                  : "Next →"}
            </button>
          </form>

          <p className="setup-footer">© QwickBit Technologies Pvt Ltd, 2026</p>
        </div>
      </div>
    </div>
  );
};

export default SetUpProfile;